<div class="header">
    <h2>{{ 'news.modal.edit.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="news-edit-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'news.error.unavailable' | translate" />
} @else if (newsItem(); as newsItem) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
        <div class="section">
            <h2>{{ 'news.fieldset.basic' | translate }}</h2>
            <app-form-input [control]="form.controls.title" [label]="'news.form.title' | translate" inputId="title" testId="news-edit-title" />
            <app-form-datepicker [control]="form.controls.date" [label]="'news.form.date' | translate" inputId="date" testId="news-edit-date" />
        </div>

        <div class="section">
            <h2>{{ 'news.fieldset.content' | translate }}</h2>
            <app-form-textarea
                [control]="form.controls.description"
                [label]="'news.form.description' | translate"
                inputId="description"
                [rows]="6"
                testId="news-edit-description"
            />
        </div>
    </form>

    <div class="footer">
        <p-button [label]="'news.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="news-edit-cancel" (onClick)="close()" />
        <p-button
            type="submit"
            [label]="'news.form.save' | translate"
            [loading]="saving()"
            [disabled]="form.disabled"
            data-test="news-edit-save"
            (onClick)="onSubmit()"
        />
    </div>
}
